<br /><br /><br /><br />
<div class="page-title">
  <mat-icon class="app-icon">monitoring</mat-icon>
  <h1 class="title-text">Safety Analytics</h1>
  <p class="form-desc">
    Filter by office and date range to view JSA, Good Catch, and Near Miss
    submission trends across the company.
  </p>
</div>
<br />

<!-- Filter bar -->
<mat-card class="filter-card mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="fetchAnalytics()">
      <div class="filter-row">
        <mat-form-field appearance="fill" class="office-field">
          <mat-label>Office</mat-label>
          <mat-select
            formControlName="office"
            multiple
            (selectionChange)="onOfficeSelectionChange()"
          >
            <mat-option [value]="ALL_OFFICES">All Offices</mat-option>
            @for (office of openOffices; track office.value) {
              <mat-option [value]="office.value">{{ office.label }}</mat-option>
            }
            <mat-divider></mat-divider>
            @for (office of archivedOffices; track office.value) {
              <mat-option [value]="office.value">{{ office.label }} (archived)</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="date-field">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="date-field">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <div class="filter-actions">
          <button mat-raised-button color="primary" type="submit">Apply</button>
          <button mat-stroked-button type="button" (click)="resetData()">Reset</button>
        </div>
      </div>
    </form>

    <p class="filter-summary">
      Showing <strong>{{ selectedOfficeLabel }}</strong> &middot;
      <strong>{{ selectedRangeLabel }}</strong>
    </p>
  </mat-card-content>
</mat-card>

@if (loading) {
  <div class="spinner-container">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
}

<mat-tab-group class="analytics-tabs" animationDuration="200ms">
  <!-- Overview -->
  <mat-tab label="Overview">
    <div class="tab-body">
      <div class="scorecard-grid">
        <div class="scorecard scorecard-jsa">
          <p class="scorecard-label">JSA Submissions</p>
          <p class="scorecard-number">{{ totalJsa }}</p>
        </div>
        <div class="scorecard scorecard-goodcatch">
          <p class="scorecard-label">Good Catches</p>
          <p class="scorecard-number">{{ totalGoodCatch }}</p>
        </div>
        <div class="scorecard scorecard-nearmiss">
          <p class="scorecard-label">Near Misses</p>
          <p class="scorecard-number">{{ totalNearMiss }}</p>
        </div>
      </div>
      <p class="note-message">
        Counts reflect the selected office and date range. JSA data tracks
        submissions post Google migration.
      </p>
    </div>
  </mat-tab>

  <!-- JSA -->
  <mat-tab label="JSA">
    <div class="tab-body">
      <p class="chart-heading">Total JSA Submissions Per Month</p>
      <div class="chart-container">
        <canvas baseChart [data]="chartData" [options]="chartOptions" [type]="'line'"></canvas>
      </div>

      <p class="chart-heading">Hazards Identified</p>
      <div class="chart-container">
        <canvas baseChart [data]="hazardChartData" [options]="hazardChartOptions" [type]="'bar'"></canvas>
      </div>

      <p class="chart-heading">Equipment Used</p>
      <div class="chart-container">
        <canvas baseChart [data]="equipmentChartData" [options]="equipmentChartOptions" [type]="'bar'"></canvas>
      </div>
    </div>
  </mat-tab>

  <!-- Good Catch & Near Miss -->
  <mat-tab label="Good Catch & Near Miss">
    <div class="tab-body">
      <p class="chart-heading">Good Catches Per Month</p>
      <div class="chart-container">
        <canvas baseChart [data]="goodCatchChartData" [options]="chartOptions" [type]="'line'"></canvas>
      </div>

      <p class="chart-heading">Near Misses Per Month</p>
      <div class="chart-container">
        <canvas baseChart [data]="nearMissChartData" [options]="chartOptions" [type]="'line'"></canvas>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<br /><br />
